import React from 'react';
import BookAPartyContainer from './BookAPartyContainer';
import HostPortalStore from './HostPortalStore';
import HostPortalActions from './HostPortalActions';
import MyPartyListContainer from './MyPartyListContainer';

export default class BookAParty extends React.Component {
    constructor(props) {
        super(props);
        this.state = HostPortalStore.getState();
        this.onChange = this.onChange.bind(this);
    }

    componentDidMount() {
        HostPortalStore.listen(this.onChange);
    }

    componentWillUnmount() {
        HostPortalStore.unlisten(this.onChange);
    }

    onChange(state) {
        this.setState(state);
    }

    render() {
        let containerToShow = this.state.showRequestSuccess ? <RequestSuccess {...this.props} /> : <BookAPartyContainer {...this.props} />;
        return (
            <div className="site-container icon_button_content animate-in" aria-live="assertive">
				<div className="blurb text-center">
					<div className="title">{this.props.resources["PWS.MyAccount.BookAPartyTitle"]}</div>
                </div>
                <div className="section-wrapper clearfix"><a href="javascript:void(0);" className="section-back-link" onClick={this.props.setView}>&laquo; &nbsp;{this.props.resources["PWS.MyAccount.BackToAccountButton"]}</a>
					<div className="dotted-HR"></div>
                    {containerToShow}
                </div>
            </div>
        );
    }
}

class RequestSuccess extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillUnmount() {
        HostPortalActions.resetSuccessState();
    }

    render() {
        return (
            <div className="animate-in">
                <div className="formSectionSubTitle text-center">{window.jenkon.resources["PWS.MyAccount.PhysicalPartySuccess"]}</div>
                <a href="javascript:void(0);" className="section-back-link" onClick={this.props.setView.bind(this,MyPartyListContainer)}>&laquo; &nbsp;{window.jenkon.resources["PWS.MyAccount.BackToMyParties"]}</a>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/HostPortal/BookAParty.js